import React, { useState, useEffect } from 'react';
import './style.css';
import Autocomplete from './Autocomplete';
import { useNavigate } from 'react-router-dom';
import RightSideMenu from './RightSideMenu'; // Import the RightSideMenu component

import { useTranslation } from './TranslationContext';

const Header_home = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false); // State for right-side menu

    const { translate, setLanguage } = useTranslation();

    // Load the language from localStorage when the component mounts
    useEffect(() => {
        const savedLanguage = localStorage.getItem('language');
        if (savedLanguage) {
            setLanguage(savedLanguage);
        }
    }, [setLanguage]);

    const handleDivClick = () => { 
        navigate('/Home');
    };

    const handlelogout = () => {
        localStorage.clear();
        navigate('/Login');
    };

    const handleDivtrack5 = () => {
        navigate('/Features');
    };

    const handleDivtrack6 = () => {
        navigate('/Help');
    };

    const handlecart = () => {
        navigate('/Addcart');
    };
    const handlelike = () => {
        navigate('/Likecart');
    };

    const handleDivtrack = () => {
        navigate('/Product');
    };

    const handleDivtrack1 = () => {
        navigate('/Home');
    };

    const handleprofile = () => {
        setIsMenuOpen(!isMenuOpen); // Toggle menu visibility
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const handleLanguageChange = (event) => {
        const selectedLang = event.target.value;
        setLanguage(selectedLang);
        localStorage.setItem('language', selectedLang);  // Save the selected language to localStorage
    };

    return (
        <div className="header">
            <div className="row" style={{marginTop:"10px"}}>
                <div className='col-md-1'>
                    <h4 className="" style={{ cursor: 'pointer',color:"#3A1A1D" }} onClick={handleDivtrack1}>
                        HOME
                    </h4>
                </div>

                <div className='col-md-1' onClick={handleDivtrack}>
                    <h4 className="" style={{ cursor: 'pointer',color:"#3A1A1D" }}>SHOP</h4>
                </div>

                <div className='col-md-1' onClick={handleDivtrack5}>
                    <h4 className="" style={{ cursor: 'pointer',color:"#3A1A1D" }}>FEATURES</h4>
                </div>

                <div className='col-md-2' onClick={handleDivtrack6}>
                    <h4 className="" style={{ cursor: 'pointer',color:"#3A1A1D",marginRight:"35px"}}>CONTACT</h4>
                </div>

                <div className='col-md-3' onClick={handleDivtrack1}>
                <img className="logout1" alt="Logout" title="Home" src={require('./img/logo.png')} />
                </div>

                <div className='col-md-1'>
                <img className="vector" alt="Group" title="Cart" src={require('./img/Vector.png')} onClick={handlecart} />
                </div>
                <div className='col-md-1'>
                <img className="vector" alt="Group" title="Like Cart" src={require('./img/heart.png')} onClick={handlelike} />
                </div>

                <div className='col-md-1'>
                <img className="vector" alt="Group" title="Profile" src={require('./img/Vector1.png')} onClick={handleprofile} />
                </div>

                <div className='col-md-1'>
                <img className="logout" alt="Logout" title="Logout" src={require('./img/logout.png')} onClick={handlelogout} />
                </div>
                
               
            </div>
           <br></br>
           <RightSideMenu isOpen={isMenuOpen} onClose={closeMenu} />
        </div>
    );
};

export default Header_home;
